/**
 * Extracts the invitation token from a URL fragment (`location.hash`).
 *
 * Security-critical (spec §8): the token is delivered only in the URL fragment
 * so it never reaches server logs, proxies, or Referer headers. This function
 * is pure and side-effect-free — it does not read or write `location`/`history`
 * itself, so it stays trivially testable and the container owns the one-time
 * read + strip.
 *
 * Returns `null` when the hash carries no token (e.g. a bare `#`, an empty
 * string, or whitespace-only content) — the caller renders the dead-link state.
 */
export function extractTokenFromHash(hash: string): string | null {
  const stripped = hash.startsWith('#') ? hash.slice(1) : hash;
  const trimmed = stripped.trim();
  return trimmed.length > 0 ? trimmed : null;
}
